import React from 'react';
import { withSnackbar } from 'notistack';
import { Container, Grid } from '@material-ui/core';
import auth from '../../../auth/authService';
import Breadcrumb from '../../common/breadcum';
import DetailsProfile from './DetailsProfile';
import Form from '../../common/form';
import { getUser } from '../../../services/userService';
import GroupList from './GroupList';
import Loading from '../../common/loading';
import PermissionsList from './PermissionsList';
import ProjectList from './ProjectList';
import RolesList from './RolesList';

import '../user.scss';

class meProfile extends Form {
  state = {
    data: {
      identification_card: '',
      name: '',
      lastname: '',
      fullname: '',
      email: '',
      roles: [],
      projects: [],
      groups: [],
      permissions: [],
      selectedRole: '',
    },
    errors: {},
    isLoading: false,
  };

  async populateUser() {
    try {
      const currentUser = auth.getCurrentUser();
      const { data: user } = await getUser(currentUser.id); //Si no.
      this.setState({ data: this.mapToViewModel(user) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace('/not-found');
    }
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.populateUser();
    this.setState({ isLoading: false });
  }

  mapToViewModel(user) {
    return {
      id: user.id,
      identification_card: user.identification_card,
      name: user.name,
      lastname: user.lastname,
      fullname: user.fullname,
      email: user.email,
      roles: user.roles,
      projects: user.projects,
      groups: user.groups,
      permissions: user.permissions,
      selectedRole: auth.getSelectedRole().id,
    };
  }

  render() {
    const { data, isLoading } = this.state;
    return (
      <Container
        maxWidth='xl'
        id='user'
        style={{ minWidth: '84vw', paddingLeft: '2em' }}
      >
        <Loading open={isLoading} />
        <Breadcrumb lastLabel={'Mi perfil'} />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4} xl={3}>
            <DetailsProfile data={data} />
          </Grid>
          <Grid container item xs={12} sm={12} md={8} xl={9}>
            <Grid item xs={12}>
              <ProjectList data={data.projects} />
              <GroupList data={data.groups} />
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={6} xl={6}>
                <RolesList data={data.roles} />
              </Grid>
              {data.permissions.length > 0 && (
                <Grid item xs={12} md={12} lg={6} xl={6}>
                  <PermissionsList data={data.permissions} />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default withSnackbar(meProfile);
